import { ThemeProvider } from "@/providers/ThemeProvider";
import { QueryProvider } from "@/providers/QueryProvider";
import { ModeProvider } from "@/providers/ModeProvider";
import { ApiConfigProvider } from "@/providers/ApiConfigProvider";
import { ModeQuerySync } from "@/components/ModeQuerySync";
import { CompanyQuerySync } from "@/components/CompanyQuerySync";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { CompanyProvider } from "@/contexts/CompanyContext";
import App from "@/App";
import config from "@/appsettings.json";

export interface AppContainerSettings {
  apiUrl?: string;
}

interface AppContainerProps {
  settings?: AppContainerSettings;
}

export default function AppContainer({ settings }: AppContainerProps) {
  // Use settings.apiUrl if provided (from app-prod), otherwise fall back to local config
  const apiBaseUrl = settings?.apiUrl || config.apiBaseUrl;

  return (
    <ModeProvider defaultMode="demo">
      <QueryProvider>
        <ModeQuerySync>
          <CompanyProvider>
            <ApiConfigProvider apiBaseUrl={apiBaseUrl}>
              <CompanyQuerySync>
                <TooltipProvider>
                  <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
                    <Toaster richColors duration={5000} closeButton />
                    <App />
                  </ThemeProvider>
                </TooltipProvider>
              </CompanyQuerySync>
            </ApiConfigProvider>
          </CompanyProvider>
        </ModeQuerySync>
      </QueryProvider>
    </ModeProvider>
  );
}
